import React from 'react'

import { dispatchHandleDeepLinking } from 'store/dispatcher/App'

import { Container, Input, Submit } from './styles'

const GetRoom = () => {
    const inputRef = React.useRef(null)

    const onSubmitClick = e => {
        e.preventDefault()

        // detect if its a key press event , if yes then check if its enter key or not
        if (e.keyCode && e.keyCode !== 13) {
            return
        }

        if (inputRef.current) {
            const roomUrl = inputRef.current.value
            dispatchHandleDeepLinking(`room-url=${roomUrl}`) // going throudh deep linking phase handler to handle environment and other things
        }
    }

    return (
        <Container>
            <Input ref={inputRef} placeholder="Enter Room URL" />
            <Submit onClick={onSubmitClick}>start</Submit>
        </Container>
    )
}

export { GetRoom }
